module.exports = __webpack_public_path__ + "img/student4.4e9fe74d.png";